/*@flow*/
import type { Element } from 'react'; /** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useState, createRef, useContext } from 'react';
import { copy } from 'lib/copy';
import cx from 'classnames';
import { select as d3Select } from 'd3-selection';
import getShareUrl from './getShareUrl';
import getEmbedUrl from './getEmbedUrl';
import Context from './Context';
import pick from 'ramda/src/pick';

const urlPropKeys = [
  'id',
  'showBoundary',
  'showDrawingTool',
  'dataPanels',
  'panelName',
  'resourceName',
  'showShapes',
  'toolbarButtons',
  'showImagesInListView',
];

export default function CopyButtons(): null | Element<string> {
  const ctx = useContext(Context);
  const urlProps = pick(urlPropKeys)(ctx.state);

  const [active, setActive] = useState('');

  if (!ctx.state.id) return null;

  const onEmbed = () => {
    const u = getEmbedUrl(urlProps);
    copy(u);
    setActive('embed');
  };

  const onShare = () => {
    const u = getShareUrl(urlProps);
    copy(u);
    setActive('share');
  };

  const ref = createRef();
  function onShowFeedback() {
    const el = ref.current;
    if (!el) return;
    if (active === '') return;
    const sel = d3Select(el);

    sel.style('opacity', 1);

    sel
      .transition()
      .duration(1000)
      .style('opacity', 0);
  }

  return (
    <div data-testid="CopyButtons">
      <div className="btn-group d-flex mb-0 mt-4">
        <button
          className={cx('btn btn-primary', { active: active === 'share' })}
          onClick={() => {
            onShowFeedback();
            onShare();
          }}
          data-testid="CopyUrlButton"
        >
          Url <i className="fa fa-link" />
        </button>
        <button
          className={cx('btn btn-primary', { active: active === 'embed' })}
          onClick={() => {
            onShowFeedback();
            onEmbed();
          }}
          data-testid="CopyEmbedCodeButton"
        >
          Embed <i className="fa fa-code" />
        </button>
      </div>
      <div
        ref={ref}
        className="position-absolute"
        css={css(`
        font-size: 0.5rem;
        bottom: 44px;
        opacity: 0;
        left: 66px;
      `)}
      >
        Copied to your clipboard!
      </div>
    </div>
  );
}
